import { render, staticRenderFns } from "./DuplicatesCheck.vue?vue&type=template&id=4febadab&scoped=true&"
import script from "./DuplicatesCheck.vue?vue&type=script&lang=js&"
export * from "./DuplicatesCheck.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatesCheck.vue?vue&type=style&index=0&id=4febadab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febadab",
  null
  
)

export default component.exports